module.exports = __webpack_public_path__ + "img/newCoinImg.2e9c63fc.png";